import { render } from "./App.vue?vue&type=template&id=3bfa1e6f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3bfa1e6f&lang=stylus"

import exportComponent from "/root/workspace/KpiManage-vue_PVju/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__